// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const ReviewsInvitationService = {
    /**
     * CreateReviewInvitation creates a new review invitation. This only returns a link to be used in the invitation.
     */
    CreateReviewInvitation(fn, _req) {
        return fn(`/reviews/invitation/v1`, { method: "POST" });
    },
    /**
     * BatchCreateReviewInvitation creates multiple review invitations in a single request. This also handles sending the SMS invitation.
     */
    BatchCreateReviewInvitation(fn, _req) {
        return fn(`/reviews/invitation/v1/batch`, { method: "POST" });
    },
    /**
     * GetReviewInvitation returns a previously created review invitation.
     */
    GetReviewInvitation(fn, req) {
        try {
            fm.validateUrlParam(req["invitationId"], "invitationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/reviews/invitation/v1/${req["invitationId"]}?${fm.renderURLSearchParams(req, ["invitationId"])}`, { method: "GET" });
    },
    /**
     * ListInvitationTemplates returns a list of templates that can be used for batch invitations.
     */
    ListInvitationTemplates(fn, req) {
        return fn(`/reviews/invitation/v1/templates?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * CreateInvitationTemplate creates a new template that can be used for batch invitations.
     */
    CreateInvitationTemplate(fn, _req) {
        return fn(`/reviews/invitation/v1/templates`, { method: "POST" });
    },
    /**
     * UpdateInvitationTemplate updates an existing template that can be used for batch invitations.
     */
    UpdateInvitationTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/reviews/invitation/v1/templates/${req["templateId"]}`, { method: "PUT" });
    },
    /**
     * DeleteInvitationTemplate deletes an existing template that can be used for batch invitations.
     */
    DeleteInvitationTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/reviews/invitation/v1/templates/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "DELETE" });
    },
};
